import { StyleSheet, View } from "react-native";
export const PageContainer = ({ children, maxWidth = 1360, header, style, }) => (<View style={styles.wrapper}>
    {header}
    <View style={[styles.container, { maxWidth }, style]}>{children}</View>
  </View>);
const styles = StyleSheet.create({
    wrapper: {
        flexGrow: 1,
        alignItems: "center",
    },
    container: {
        paddingHorizontal: 40,
        paddingVertical: 64,
        width: "100%",
    },
});
//# sourceMappingURL=PageContainer.js.map